import { AboutMenu, Category } from "@hermes/api-model-menu";

import { MenuLink } from "../model/menu.model";

export const extractLinksFromMenuEntriesFromDiscovery = (
    menuEntryList: Category[] | undefined,
    menuLinks: MenuLink[] = [],
): MenuLink[] => {
    if (menuEntryList) {
        menuEntryList
            .filter((menuEntry) => menuEntry.visibility)
            .forEach((menuEntry) => {
                extractLinksFromMenuEntriesFromDiscovery(
                    menuEntry.subcategories,
                    menuLinks,
                );

                if (menuEntry.categoryPath) {
                    menuLinks.push({
                        path: menuEntry.categoryPath,
                        label: cleanMenuEntryDiscoveryName(menuEntry.name),
                    });
                }
            });
    }

    return menuLinks;
};

export const extractLinksFromAboutEntriesFromDiscovery = (
    menuEntryList: AboutMenu[] | undefined,
    menuLinks: MenuLink[] = [],
): MenuLink[] => {
    if (menuEntryList) {
        menuEntryList.forEach((menuEntry) => {
            extractLinksFromAboutEntriesFromDiscovery(
                menuEntry.items,
                menuLinks,
            );

            if (menuEntry.data) {
                menuLinks.push({
                    path: menuEntry.data,
                    label: cleanMenuEntryDiscoveryName(menuEntry.label),
                });
            }
        });
    }

    return menuLinks;
};

/**
 * Level 1 menu entry can have &nbsp; or <wbr> in name to be well displayed
 * on horizontal menu, on the majority of occasion we want the name to be clean
 */
export const cleanMenuEntryDiscoveryName = (input: string) =>
    input.replace(/&nbsp;/g, " ").replace(/<wbr>/g, "");
